import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { confirmForceEditTicket } from '../handler/TicketListHandler';

export const DialogConfirmForceEditTicket = props => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const isOpen = props.confirmForceEditTicket?.method > 0 ? true : false;

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setConfirmForceEditTicket({
            method: 0,
            requestDto: {}
        });
    };

    const onSubmitForceChangeAssign = () => {
        switch (props.confirmForceEditTicket?.method) {
            case Constant.UPDATE_TICKET_METHOD.UPDATE_ASSIGNEE:
                confirmForceEditTicket(props, Constant.UPDATE_TICKET_METHOD.UPDATE_ASSIGNEE);
                break;
            case Constant.UPDATE_TICKET_METHOD.UPDATE_STATUS:
                confirmForceEditTicket(props, Constant.UPDATE_TICKET_METHOD.UPDATE_STATUS);
                break;
            case Constant.UPDATE_TICKET_METHOD.FORCE_EDIT_ASSIGNEE_AND_STATUS:
                confirmForceEditTicket(
                    props,
                    Constant.UPDATE_TICKET_METHOD.FORCE_EDIT_ASSIGNEE_AND_STATUS
                );
                break;
            default:
                // do nothing
        }
        
        props.setConfirmForceEditTicket({
            method: 0,
            requestDto: {}
        });
    }

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {trI18n('USER04MSG024')}
                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onSubmitForceChangeAssign}
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
